// extracted by mini-css-extract-plugin
module.exports = {"regularFontWeight":"styles_regularFontWeight__2QkrL","detail":"styles_detail__23D5G"};